import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Datatable from '../../components/shared/datatable/Datatable';
import AssignOdoSurveyModal from '../../components/shared/modalContent/AssignOdoSurveyModal';
import { getStatusClass } from '../../helpers/Utils';
import { useGetAssignedOddoSurveyByIdQuery } from '../../app/surveyApi/surveyApi';
import CommonBreadcrumb from '../../components/shared/breadcrumb/CommonBreadcrumb';

const OdoUserDetails = () => {
  const location = useLocation();
  const userName = location.state?.userName;
  const userEmail = location.state?.userEmail;
  const { id } = useParams();

  const [showAssignOdoSurveyModal, setShowAssignOdoSurveyModal] = useState(false);
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(1);
  const [formattedSurveys, setFormattedSurveys] = useState(null);

  const { data: assignedSurveysData, isLoading, isFetching } = useGetAssignedOddoSurveyByIdQuery({
    leadId: id, // use param instead of hardcoded 413
    page,
    limit: 10,
    search,
  }, { skip: !id });


  // 🟡 Transform API response to match `Datatable` expected structure
  useEffect(() => {
    if (assignedSurveysData) {
        console.log(assignedSurveysData,"assignedSurveysData-->");
      const { assignedSurveys, ...rest } = assignedSurveysData?.data;
      
 
     
      
      setFormattedSurveys({
        ...rest,
        data: assignedSurveys,
      });
    }
  }, [assignedSurveysData]);

  const handleFilterSearch = (value) => {
    setSearch(value);
    setPage(1);
  };
console.log(formattedSurveys,"formattedSurveys");

  const columns = [
    { label: 'Survey Title', accessor: 'title' },
    { label: 'Description', accessor: 'description' },
 
  ];

 const breadcrumbItems = [
    { label: 'Users', path: '/users' },
    { label: `User Details - ${id}` }, // last one (no path) is the current page
  ];
  return (
  
      <div>
        <CommonBreadcrumb items={breadcrumbItems} />
      <AssignOdoSurveyModal
        show={showAssignOdoSurveyModal}
        setShow={setShowAssignOdoSurveyModal}
        userId={id}
        getOdoUser={true}
      />

      <Datatable
        tableData={formattedSurveys}
        columns={columns}
        page={page}
        onPageChange={(newPage) => setPage(newPage)}
        isLoading={isLoading}
        isFetching={isFetching}
        showPegination={true}
        showFilter={true}
        title={userName}
        subTitle={userEmail}
        buttonTitle="Assign Survey"
        onFilterSearch={handleFilterSearch}
        onClick={() => setShowAssignOdoSurveyModal(true)}
      />
    </div>
  );
};

export default OdoUserDetails;
